import React from 'react';

// Sélecteur de rubrique HITL affiché sous l'aperçu d'un article (publication site).
// L'humain CHOISIT la rubrique dans la liste réelle du site (l'IA ne l'invente plus).
// Choix explicite obligatoire : tant qu'aucune rubrique n'est choisie, les boutons
// « Mettre en ligne » / « Brouillon » restent désactivés (géré dans ActionButtons).
// Props : rubriques [{slug,label}], value (slug ou ''), onChange(slug), disabled.
export default function RubriqueSelect({ rubriques, value, onChange, disabled = false }) {
  if (!Array.isArray(rubriques) || rubriques.length === 0) return null;

  return (
    <div style={{ marginTop: '12px', marginBottom: '2px', maxWidth: '340px' }}>
      <label
        style={{
          display: 'block',
          fontSize: '12px',
          fontWeight: 600,
          color: 'var(--text-secondary)',
          marginBottom: '6px',
        }}
      >
        Rubrique de publication <span style={{ color: '#dc2626' }}>*</span>
      </label>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        style={{
          width: '100%',
          padding: '9px 12px',
          borderRadius: '10px',
          border: '1px solid var(--card-border)',
          background: 'var(--input-bg, var(--card-bg))',
          color: 'var(--text)',
          fontSize: '13px',
          fontWeight: 500,
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
          transition: 'all 0.15s',
        }}
      >
        <option value="">— Choisir une rubrique —</option>
        {rubriques.map((r) => (
          <option key={r.slug} value={r.slug}>{r.label || r.slug}</option>
        ))}
      </select>
    </div>
  );
}
